import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import FooterMainUniversal from './FooterMainUniversal';
import { locationActions, userActions } from '../../actions';

const MAX_FOOTER_DELIVERY_AREAS = 25;

const FooterMainUniversalContainer = React.memo(
  ({ dispatch, pickupLocations, footer, message, seoEnabled, seoReady, menuAvailability, ...props }) => {
  const [deliveryAreas, setDeliveryAreas] = useState([]);

  useEffect(() => {
    if (menuAvailability.dispensaries === false) return;
    dispatch(locationActions.getPickupLocations());
  }, []);

  useEffect(() => {
    if (menuAvailability.deliveryAreas === false) return;
    locationActions
      .getLocationPagesByStore('')
      .then((data) => setDeliveryAreas(Array.isArray(data) ? data.slice(0, MAX_FOOTER_DELIVERY_AREAS) : []))
      .catch(() => {});
  }, []);

  const handleSubscribe = (formData) => {
    dispatch(userActions.subscribeEmailFooter(formData));
  };

    return (
      <FooterMainUniversal
        pickupLocations={pickupLocations}
        deliveryAreas={deliveryAreas}
        footer={footer}
        message={message}
        seoEnabled={seoEnabled}
        seoReady={seoReady}
        menuAvailability={menuAvailability}
        onSubscribe={handleSubscribe}
        {...props}
      />
    );
  }
);

const mapStateToProps = ({ pickupLocations, storeInfo, alert, menuAvailability }) => ({
  pickupLocations: pickupLocations.pickupLocations || [],
  footer: storeInfo.storeInfo && storeInfo.storeInfo.footer,
  seoEnabled: storeInfo.storeInfo?.features?.seoEnabled,
  seoReady: !!storeInfo.storeInfo,
  message: alert.message,
  menuAvailability,
});

export default connect(mapStateToProps)(FooterMainUniversalContainer);
